import React from 'react';
import { Fade } from 'react-awesome-reveal';
import HeaderCarousel from '../components/HeaderCarousel';
import FactItem from '../components/FactItem';
import AboutSection from '../components/AboutSection';
import ProductSection from '../components/ProductSection';
import ServiceSection from '../components/ServiceSection';
import TeamSection from '../components/TeamSection';
import TestimonialSection from '../components/TestimonialSection';
import VirtualTour from '../components/VirtualTour';
import TimelineOverview from '../components/TimelineOverview';

const Home = () => {
  return (
    <>
    <div className="area-bg-pattern"></div>
      <HeaderCarousel />
      <Fade triggerOnce>
       <div className="container-xxl py-6 py-md-4 py-sm-3">
  <div className="container">
    <div className="row g-3 g-md-4">  
      <FactItem 
        icon="fa fa-building" 
        label="Commercial Projects" 
        value={275} 
        delay={100} 
        suffix="+"
      />
      <FactItem 
        icon="fa fa-home" 
        label="Residential Designs" 
        value={153} 
        delay={300} 
        suffix="+"
      />
      <FactItem 
        icon="fa fa-clock" 
        label="On-time Delivery" 
        value={100} 
        delay={500} 
        suffix="%"
      />
      <FactItem 
        icon="fa fa-globe" 
        label="Countries Served" 
        value={15} 
        delay={700} 
        suffix="+"
      />
    </div>
  </div>
</div>
      </Fade>
      <AboutSection />
      <VirtualTour/>
      <ProductSection />
      <ServiceSection />
      <TimelineOverview/>
      <TeamSection />
      <TestimonialSection />
    </>
  );
};

export default Home;






